import { useContext, useState } from 'react';
import { Form, Formik } from 'formik';
import { Button, ModalBody, ModalHeader } from 'reactstrap';
import * as yup from 'yup';
import { useParams } from 'react-router';
import Modal from '../../basics/Modal';
import { ValidatedInput } from '../../templates/template-components';
import { MapContext } from '../../../contexts/MapContext';
import { mapModes } from '../../../constants/map';
import { uniqueName } from '../../../utils/utils';
import useMutateWithState from '../../../hooks/useMutateWithState';
import { captureEvent } from '../../../utils/analytics';

const validationSchema = yup.object({
  name: yup.string().required('Required'),
});

const CreateSectionGroupModal = ({ hide }) => {
  const [{ loading }, mutateAndSetState] = useMutateWithState();
  const [userHasTyped, setUserHasTyped] = useState(false);

  const { farmId } = useParams();
  const {
    mapState: { selectedFieldIds, setMapMode },
    sectionGroups: { sectionGroups, createSectionGroup },
  } = useContext(MapContext);
  const initialValues = {
    farmId,
    name: uniqueName('Section Group', sectionGroups),
    sectionIds: selectedFieldIds.toArray(),
  };
  const focusNameInput = (el) => {
    if (!el || userHasTyped) return;
    el.focus();
    el.select();
  };
  return (
    <Modal isOpen toggle={() => !loading && hide()} size="sm">
      <ModalHeader className="font-xl">Create Section Group</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            mutateAndSetState(() => createSectionGroup(values)).then(
              (response) => {
                const result = response.data?.upsertSectionGroup?.result;
                if (result) {
                  setMapMode(mapModes.SECTION_GROUP_ENGAGED, result.id, {
                    sectionGroup: result,
                  });
                  hide();
                  captureEvent('section-group-created');
                }
              },
            );
          }}
          validationSchema={validationSchema}
        >
          <Form>
            <ValidatedInput
              name="name"
              label="Name"
              inputRef={focusNameInput}
              onKeyDown={() => setUserHasTyped(true)}
            />
            <div className="d-flex justify-content-end">
              <Button
                type="button"
                color="secondary"
                size="sm"
                onClick={hide}
                disabled={loading}
                outline
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="primary"
                size="sm"
                className="ml-2"
                disabled={loading}
              >
                Save
              </Button>
            </div>
          </Form>
        </Formik>
      </ModalBody>
    </Modal>
  );
};

const CreateSectionGroupButton = () => {
  const [showSectionGroupModal, setShowSectionGroupModal] = useState(false);
  const onButtonClick = () => {
    setShowSectionGroupModal(true);
    captureEvent('section-group-create-clicked');
  };

  return (
    <>
      <Button size="sm" outline className="mr-2" onClick={onButtonClick}>
        Create Group
      </Button>
      {showSectionGroupModal && (
        <CreateSectionGroupModal hide={() => setShowSectionGroupModal(false)} />
      )}
    </>
  );
};

export default CreateSectionGroupButton;
